export default __webpack_public_path__ + "static/media/cookie.dc776f5b.png";